export default __webpack_public_path__ + "static/tech-a9c6ed9355eb8979a411fb596dc99143.webp";